import { useRef, useState } from "react";
import s from "./ResizeHandle.module.css";

/**
 * Drag handle on a panel edge. `edge` is which side of the PANEL the handle
 * sits on: "left" panel handles sit on its right edge and vice versa.
 */
export function ResizeHandle({
  side,
  onResize,
  onDoubleClick,
}: {
  side: "left" | "right";
  onResize: (delta: number) => void;
  onDoubleClick?: () => void;
}) {
  const [dragging, setDragging] = useState(false);
  const lastX = useRef(0);

  return (
    <div
      className={[s.handle, side === "left" ? s.left : s.right, dragging ? s.dragging : ""].join(" ")}
      onDoubleClick={onDoubleClick}
      onPointerDown={(e) => {
        e.preventDefault();
        (e.target as HTMLElement).setPointerCapture(e.pointerId);
        lastX.current = e.clientX;
        setDragging(true);
      }}
      onPointerMove={(e) => {
        if (!dragging) return;
        const delta = e.clientX - lastX.current;
        if (delta !== 0) {
          lastX.current = e.clientX;
          onResize(side === "left" ? delta : -delta);
        }
      }}
      onPointerUp={(e) => {
        (e.target as HTMLElement).releasePointerCapture(e.pointerId);
        setDragging(false);
      }}
    />
  );
}
